import {
  CButton,
  CCard,
  CCardBody,
  CCardGroup,
  CCol,
  CContainer,
  CForm,
  CFormCheck,
  CFormInput,
  CFormLabel,
  CRow,
} from "@coreui/react";
import React, { useEffect, useState } from "react";
import en from "react-phone-number-input/locale/en";
import { useLocation } from "react-router-dom";
import {
  getCustomerbyid,
  getPaymentDetails,
  getForwardingOffices,
  updateDetailStatusByCustomer,
} from "src/api/commonapi";
import { Routes } from "src/constants/api_url";
import Select from "react-select";
import CustomImage from "src/views/CommonFunctions/CustomImage";
import { fetchAttributesbyid } from "src/api/common";
import { DisptchSelect } from "src/views/CommonFunctions/common";
import { notification } from "src/constants/message";
import cross from "./cross.jpg";
import { ClipLoader } from "react-spinners";

const DispatchingDocForm = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const code = queryParams.get("code");
  const defaultData = {
    courier_id: 0,
    city: "",
    pincode: "",
    d_address: "",
    is_courier: false,
  };
  const [companyname, setCompnyname] = useState([]);
  const [custData, setCustData] = useState(defaultData);
  const [submitResponse, setSubmitResponse] = useState(0);
  const [paymentData, setPaymentData] = useState();
  const [step, setStep] = useState(0);
  const [deliveryType, setDeliveryType] = useState(1);
  const [forwardingOffices, setForwardingOffices] = useState([]);
  const [selectedOffice, setSelectedOffice] = useState(null);

  useEffect(async () => {
    let courierCompanyResponse = await fetchAttributesbyid(16);
    setCompnyname(
      courierCompanyResponse?.sort((a, b) => a.attribute_id - b.attribute_id),
    );
    const plain = Buffer.from(code, "base64").toString("utf8");
    const cId = parseInt(plain?.split("_")[0]);
    let resp = await getCustomerbyid(cId);
    setCustData({
      city: resp.result.city,
      pincode: resp.result.pincode,
      n_d_address: resp.result.n_d_address,
      d_address: resp.result.d_address,
      courier_id: resp.result.courier_id || 0,
      country_code: resp.result.country_code || 91,
      c_mo_no: resp.result.c_mo_no || "",
      is_courier: resp.result.courier_id == 0 ? false : true,
    });
    let paymentDetails = await getPaymentDetails(cId);
    setPaymentData(paymentDetails?.data);
    await getForwardingOfficesFunction(cId);
  }, []);

  const getForwardingOfficesFunction = async (cId) => {
    try {
      let officeData = await getForwardingOffices(cId);
      if (officeData?.status == 1 && officeData?.offices?.length > 0) {
        let allOptions = officeData.offices.map((o) => ({
          value: o.attribute_id,
          label:
            o.name + (o.destination_name ? ` (${o.destination_name})` : ""),
          is_home_branch: o.is_home_branch,
          destination_id: o.destination_id,
          isOriginal:
            officeData.originalDestIds?.includes(o.attribute_id) ||
            officeData.originalDestIds?.includes(o.destination_id),
        }));
        let origOptions = allOptions.filter((o) => o.isOriginal);
        let otherOptions = allOptions.filter((o) => !o.isOriginal);
        let groupedOptions = [];
        if (origOptions.length > 0) {
          groupedOptions.push({
            label: "Your Destinations",
            options: origOptions,
            labelColor: "#a4a7aa",
          });
        }
        if (otherOptions.length > 0) {
          groupedOptions.push({
            label: "Other Offices",
            options: otherOptions,
            labelColor: "#a4a7aa",
          });
        }
        setForwardingOffices(groupedOptions);
        if (origOptions.length > 0) {
          setSelectedOffice(origOptions[0]);
        }
      }
    } catch (e) {
      console.log("Error fetching forwarding offices", e);
    }
  };  

  const updateDetailStatusFunction = async () => {
    if (deliveryType === 0 && !selectedOffice) {
      let notify = notification({
        type: "error",
        message: "Please select an office address",
      });
      notify();
      return;
    }
    if (deliveryType === 1) {
      if (custData?.city?.trim() == "" || custData?.d_address.trim() == "") {
        let notify = notification({
          type: "error",
          message: "Please add City or Address",
        });
        notify();
        return;
      }
    }
    if (deliveryType === null || deliveryType === undefined) {
      let notify = notification({ 
        type: "error",
        message: "Please select delivery type",
      });
      notify();
      return;
    }
    setStep(1);
    let fdata = new FormData();
    Object.keys(custData)?.map((key) => {
      fdata.append(key, custData[key]);
    });
    const plain = Buffer.from(code, "base64").toString("utf8");
    fdata.append("c_id", parseInt(plain?.split("_")[0]));
    if (deliveryType === 0 && selectedOffice) {
      fdata.append("is_forwarding", 1);
      fdata.append("selected_office_id", selectedOffice.value);
    } else {
      fdata.append("is_forwarding", 0);
    }
    const resp = await updateDetailStatusByCustomer(fdata);
    let notify = notification({
      type: resp.status == 0 ? "error" : "success",
      message: resp.message,
    });
    notify();
    if (resp.status == 0 || resp.status == 2) {
      setStep(0);
    }
    if (resp.status == 1) {
      setSubmitResponse(1);
      setStep(0);
      setCustData(defaultData);
    }
  };

  const formatGroupLabel = (group) => (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        padding: "6px 0",
        fontWeight: 700,
        fontSize: "13px",
        color: group.labelColor || "#333",
        borderBottom: `2px solid ${group.labelColor || "#333"}`,
        marginBottom: 4,
      }}
    >
      {group.label}
    </div>
  );

  return (
    <>
      <div className="d-flex flex-row">
        <CContainer>
          {paymentData ? (
            submitResponse == 0 &&
            (paymentData?.due_amt == 0 ||
              paymentData?.net_amt ==
                parseInt(paymentData?.paid_amt) +
                  parseInt(paymentData?.total_draft)) ? (
              <>
                <div className="center-hor-ver">
                  <div
                    className="form-container-cus bg-white my-5"
                    style={{
                      maxWidth: "950px",
                      width: "100%",
                      minHeight: "90vh",
                      display: "flex",
                      flexDirection: "column",
                    }}
                  >
                    <div style={{ flex: "1 1 auto", overflow: "visible" }}>
                      <CRow>
                        <CCol xs={12} className="text-center mb-3">
                          <CustomImage
                            src={`${Routes.API_HOSTNAME}/images/adminlogo/loginlogo.png`}
                            className="cus_form_logo"
                          />
                          <h5
                            className="form_title text-center"
                            style={{ color: "black" }}
                          >
                            Review or Update the Form with Your Postal Address.
                          </h5>
                          <div style={{ color: "red" }} className="mb-2">
                            Do not enter the overseas address if you have not
                            paid the DHL cost. DHL cost applied in advance
                          </div>
                        </CCol>

                        <CCol xs={12} md={5} className="mb-md-0">
                          <div
                            onClick={() => setDeliveryType(1)}
                            style={{
                              background:
                                deliveryType === 1 ? "#d4edda" : "#f8f9fa",
                              border:
                                deliveryType === 1
                                  ? "2px solid #28a745"
                                  : "1px solid #dee2e6",
                              borderRadius: 8,
                              padding: "8px 16px",
                              cursor: "pointer",
                              textAlign: "center",
                              transition: "all 0.3s ease",
                              minHeight: "80px",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            <CFormCheck
                              type="radio"
                              id="homeDelivery"
                              name="deliveryType"
                              checked={deliveryType === 1}
                              onChange={() => setDeliveryType(1)}
                              label=""
                              style={{ display: "none" }}
                            />
                            <div
                              style={{
                                fontWeight: 400,
                                fontSize: "18px",
                                color: "#000",
                              }}
                            >
                              Click here for free home delivery service
                            </div>
                          </div>
                        </CCol>

                        <CCol
                          xs={12}
                          md={2}
                          className="d-flex align-items-center justify-content-center my-2 my-md-0"
                        >
                          <div
                            style={{
                              background: "#ffc107",
                              color: "#000",
                              borderRadius: 8,
                              padding: "8px 16px",
                              fontWeight: 500,
                              fontSize: "22px",
                            }}
                          >
                            or
                          </div>
                        </CCol>

                        <CCol xs={12} md={5}>
                          <div
                            onClick={() => setDeliveryType(0)}
                            style={{
                              background:
                                deliveryType === 0 ? "#d4edda" : "#f8f9fa",
                              border:
                                deliveryType === 0
                                  ? "2px solid #28a745"
                                  : "1px solid #dee2e6",
                              borderRadius: 8,
                              padding: "8px 16px",
                              cursor: "pointer",
                              textAlign: "center",
                              transition: "all 0.3s ease",
                              minHeight: "80px",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            <CFormCheck
                              type="radio"
                              id="collectOffice"
                              name="deliveryType"
                              checked={deliveryType === 0}
                              onChange={() => setDeliveryType(0)}
                              label=""
                              style={{ display: "none" }}
                            />
                            <div
                              style={{
                                fontWeight: 400,
                                fontSize: "18px",
                                color: "#000",
                              }}
                            >
                              Will you collecting from our office
                            </div>
                          </div>
                        </CCol>
                      </CRow>

                      <CRow
                        className="mt-4"
                        style={{ position: "relative", zIndex: 1 }}
                      >
                        <CCol xs={12}>
                          {deliveryType === 1 && (
                            <div
                              style={{
                                background: "#f8f9fa",
                                border: "1px solid #dee2e6",
                                borderRadius: 8,
                                padding: 16,
                                maxWidth: "500px",
                                margin: "0 auto",
                              }}
                            >
                              <CForm>
                                <div className="mb-3">
                                  <CFormLabel style={{ color: "black" }}>
                                    Select Courier Company (Optional)
                                  </CFormLabel>
                                  <Select
                                    value={companyname?.map((u) => {
                                      if (
                                        u.attribute_id == custData?.courier_id
                                      ) {
                                        return {
                                          value: u.attribute_id,
                                          label: u.name,
                                        };
                                      } else return null;
                                    })}
                                    options={
                                      companyname &&
                                      companyname
                                        ?.filter(
                                          (item) =>
                                            !item?.name
                                              ?.toLowerCase()
                                              ?.startsWith("dhl") &&
                                            !item?.name
                                              ?.toLowerCase()
                                              ?.startsWith("fedex") &&
                                            !item?.name
                                              ?.toLowerCase()
                                              ?.startsWith("aramex") &&
                                            item?.attribute_id != 520 &&
                                            item?.attribute_id != 191 &&
                                            item?.attribute_id != 522 &&
                                            item?.attribute_id != 837 &&
                                            item?.attribute_id != 755,
                                        )
                                        ?.map((ls) => ({
                                          value: ls.attribute_id,
                                          label: ls.name,
                                        }))
                                    }
                                    onChange={(e) =>
                                      setCustData({
                                        ...custData,
                                        courier_id: e.value,
                                      })
                                    }
                                    isDisabled={custData?.is_courier}
                                  />
                                </div>
                                <div className="mb-3">
                                  <CRow>
                                    <CCol xs={12} sm={5}>
                                      <CFormLabel>Country Code</CFormLabel>
                                      <DisptchSelect
                                        labels={en}
                                        value={custData?.country_code}
                                        onChange={(countryCode, country) => {
                                          setCustData((prev) => ({
                                            ...prev,
                                            country_code: country,
                                            countryCode: countryCode,
                                            c_mo_no: "",
                                          }));
                                        }}
                                      />
                                    </CCol>
                                    <CCol xs={12} sm={7}>
                                      <CFormLabel>Contact Number</CFormLabel>
                                      <CFormInput
                                        value={custData?.c_mo_no}
                                        type="text"
                                        name="c_mo_no"
                                        placeholder="Enter Contact Number"
                                        onChange={(e) => {
                                          let val = e.target.value.replace(
                                            /[^0-9]/g,
                                            "",
                                          );
                                          val =
                                            custData?.country_code == "IN"
                                              ? val.slice(0, 10)
                                              : val.slice(0, 15);
                                          setCustData({
                                            ...custData,
                                            c_mo_no: val,
                                          });
                                        }}
                                      />
                                    </CCol>
                                  </CRow>
                                </div>
                                <div className="mb-1">
                                  <CFormLabel style={{ color: "black" }}>
                                    City
                                  </CFormLabel>
                                  <CFormInput
                                    value={custData?.city}
                                    type="text"
                                    onChange={(e) =>
                                      setCustData({
                                        ...custData,
                                        city: e.target.value,
                                      })
                                    }
                                  />
                                </div>
                                <div className="mb-1">
                                  <CFormLabel style={{ color: "black" }}>
                                    Pincode
                                  </CFormLabel>
                                  <CFormInput
                                    value={custData?.pincode}
                                    type="text"
                                    onChange={(e) =>
                                      setCustData({
                                        ...custData,
                                        pincode: e.target.value,
                                      })
                                    }
                                  />
                                </div>
                                <div className="mb-1">
                                  <CFormLabel style={{ color: "black" }}>
                                    Address
                                  </CFormLabel>
                                  <textarea
                                    name="d_address"
                                    className="form-control"
                                    style={{ wordBreak: "break-word" }}
                                    placeholder="Client Address"
                                    value={custData?.d_address}
                                    rows={5}
                                    onChange={(e) =>
                                      setCustData({
                                        ...custData,
                                        d_address: e.target.value,
                                      })
                                    }
                                  ></textarea>
                                </div>
                              </CForm>
                            </div>
                          )}

                          {deliveryType === 0 && (
                            <div
                              style={{
                                background: "#f8f9fa",
                                border: "1px solid #dee2e6",
                                borderRadius: 8,
                                padding: 16,
                                maxWidth: "500px",
                                margin: "0 auto",
                                position: "relative",
                              }}
                            >
                              <CFormLabel
                                style={{ color: "black", fontWeight: 600 }}
                              >
                                Select Office Address
                              </CFormLabel>
                              <div
                                className="mt-2"
                                style={{ position: "relative" }}
                              >
                                <Select
                                  value={selectedOffice}
                                  options={forwardingOffices}
                                  onChange={(e) => setSelectedOffice(e)}
                                  placeholder="Select Office Address"
                                  formatGroupLabel={formatGroupLabel}
                                />
                                {forwardingOffices.length === 0 && (
                                  <div
                                    style={{ color: "#888", fontSize: "13px" }}
                                    className="mt-1"
                                  >
                                    No forwarding offices available
                                  </div>
                                )}
                              </div>
                            </div>
                          )}

                          {!deliveryType && (
                            <div
                              style={{
                                textAlign: "center",
                                color: "#888",
                                padding: "20px 0",
                                fontSize: "16px",
                              }}
                            >
                              Please select a delivery option above
                            </div>
                          )}
                        </CCol>
                      </CRow>
                    </div>

                    <div
                      style={{
                        flexShrink: 0,
                        borderTop: "1px solid #eee",
                        padding: "12px 0",
                        marginTop: "auto",
                      }}
                    >
                      <div className="d-flex justify-content-end pe-3">
                        <CButton
                          disabled={step == 0 ? false : true}
                          color="primary"
                          onClick={() => updateDetailStatusFunction()}
                        >
                          Submit
                        </CButton>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            ) : (
              <>
                {paymentData?.due_amt != 0 &&
                paymentData?.net_amt !=
                  parseInt(paymentData?.paid_amt) +
                    parseInt(paymentData?.total_draft) ? (
                  <CRow className="justify-content-center align-items-center">
                    <CCol md={5} style={{ width: "600px" }}>
                      <CCardGroup>
                        <CCard
                          className="p-4"
                          style={{ border: "1px solid black" }}
                        >
                          <h3
                            className="form_title text-center"
                            style={{ color: "black" }}
                          >
                            Your Payment is still Due
                          </h3>
                          <CCardBody>
                            <CustomImage src={cross} className="cross_img" />
                            <CForm className="dsgrid">
                              <h5
                                className="text-center mb-3"
                                style={{ color: "#000" }}
                              >
                                Please provide the Due Payment Details, Full
                                address with PIN code, and Contact Number for
                                Dispatching the Document
                              </h5>
                              <h2
                                className="text-center mb-3"
                                style={{ color: "#000" }}
                              >
                                Thank You
                              </h2>
                            </CForm>
                          </CCardBody>
                        </CCard>
                      </CCardGroup>
                    </CCol>
                  </CRow>
                ) : (
                  <CRow className="justify-content-center">
                    <CCol md={5} style={{ width: "600px" }}>
                      <CCardGroup>
                        <CCard className="p-4">
                          <CCardBody>
                            <CForm className="dsgrid">
                              <CustomImage
                                src={`${Routes.API_HOSTNAME}/images/adminlogo/check.png`}
                                className="mb-3 center_img"
                              />
                              <h5
                                className="text-center mb-3"
                                style={{ color: "#000" }}
                              >
                                We have noted the completion of the Dispatching
                                Process.
                              </h5>
                              <h2
                                className="text-center mb-3"
                                style={{ color: "#000" }}
                              >
                                Thank You
                              </h2>
                            </CForm>
                          </CCardBody>
                        </CCard>
                      </CCardGroup>
                    </CCol>
                  </CRow>
                )}
              </>
            )
          ) : (
            <div className="center-hor-ver">
              <div className="form-container-cus bg-white my-5">
                <CRow>
                  <CCol md={12} className="text-center mt-3">
                    <h5
                      className="form_title text-center"
                      style={{ color: "black" }}
                    >
                      Please Wait
                    </h5>
                  </CCol>
                  <CCol md={12} className="text-center m-1 p-4">
                    <ClipLoader color="#228ce4" loading={true} size={35} />
                  </CCol>
                </CRow>
              </div>
            </div>
          )}
        </CContainer>
      </div>
    </>
  );
};

export default DispatchingDocForm;
